/*
   On the element you want to count up, include the following properties as attributes on that same element:
   data-total: The final amount it counts up to and then stops at.
   data-speed: Optional speed for the animation, smaller is faster.
   data-delay: Optional delay before the counter starts, in ms so 1000 = 1 second. Useful if you have other animations in a block to coordinate with.
   data-currency: Optional boolean that can be used to add a $ prefix to the output.
*/
const countUp = (elem:HTMLElement) => {
   const value:number = +parseInt(elem.getAttribute('data-total').replace(/\D/gm, ""));
   const data:number = +parseInt(elem.innerText.replace(/\D/gm, ""));
   let speed:number = 200;
   if(elem.hasAttribute("data-speed")) {
      speed = parseInt(elem.getAttribute("data-speed"));
   }

   let numberFormatterOptions = {minimumFractionDigits: 0, maximumFractionDigits: 0};
   if(elem.hasAttribute("data-currency") && elem.getAttribute("data-currency").toLowerCase() == "true") {
      numberFormatterOptions['style'] = 'currency';
      numberFormatterOptions['currency'] = 'USD';
   }

   const numberFormatter = new Intl.NumberFormat('en-US', numberFormatterOptions);

   const time:number = value / speed;
   if(data < value) {
      // Safari cannot use lookahead or lookbehind regex operators, need to do this without any regex.
      // elem.innerText = currencyPrefix + String(Math.ceil(data + time)).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.innerText = String(numberFormatter.format(Math.ceil(data + time)));
      window.setTimeout(() => countUp(elem), 1);
   } else {
      // Safari cannot use lookahead or lookbehind regex operators, need to do this wihtout any regex.
      // elem.innerText = currencyPrefix + String(value).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.innerText = String(numberFormatter.format(value));
   }
}

const countOnScroll = (entries: IntersectionObserverEntry[]) => {
   entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
         if(entry.target.hasAttribute("data-delay")) {
            window.setTimeout(() => countUp(entry.target as HTMLElement), parseInt(entry.target.getAttribute("data-delay").replace(/\D/gm, "")));
         } else {
            countUp(entry.target as HTMLElement);
         }
      }
   });
};

const animateObserver = new IntersectionObserver(countOnScroll, { threshold: 1 });
const animatedElements = document.querySelectorAll('.js-number-counter');
animatedElements.forEach((element:HTMLElement) => animateObserver.observe(element));